module.exports = __webpack_public_path__ + "img/jingzhuang12.ece9e68f.jpg";